import { CommentModal } from './CommentModal';

export default CommentModal;
